import { render, staticRenderFns } from "./VideoBottomBar.vue?vue&type=template&id=50daeeb5"
import script from "./VideoBottomBar.vue?vue&type=script&lang=ts"
export * from "./VideoBottomBar.vue?vue&type=script&lang=ts"
import style0 from "./VideoBottomBar.vue?vue&type=style&index=0&id=50daeeb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports